import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import React from 'react';
import { PaymentMaster } from '../../utils/constant';
import { RootState, RootStateType } from '../../redux-store/reducers';
import { useSelector } from 'react-redux';
// import { isOverseasBankApplication } from '../../utils/utilityFunctions';

function PaymentSelector({
  name,
  value,
  onChange,
  isOnlinePaymentEnabled,
}: {
  name: string;
  value: string;
  onChange: (value: string) => void;
  isOnlinePaymentEnabled: boolean;
}) {
  const { application } = useSelector((store: RootStateType) => store.application);
  // const { banks = [] } = application || {};
  //   const isOverseas = isOverseasBankApplication(application);
  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <FormLabel component="legend" sx={{ mb: 2, fontSize: 16, fontWeight: 600 }}>
        Select Payment Mode
      </FormLabel>
      <RadioGroup
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{ gap: 2 }}>
        {Object.keys(PaymentMaster)
          //   .filter((key) => (isOverseas ? key === 'offline' : true))
          .map((key) => {
            const isDisabled = key === 'online' && !isOnlinePaymentEnabled;
            const isSelected = value === key;
            return (
              <FormControlLabel
                key={key}
                value={key}
                control={<Radio />}
                label={
                  <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
                    {PaymentMaster[key]}
                    {PaymentMaster[key] === PaymentMaster.online && (
                      <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
                        (For HDFC, IDFC, Axis, ICICI, Kotak banks only)
                      </Typography>
                    )}
                  </Typography>
                }
                disabled={isDisabled}
                sx={{
                  mx: 0,
                  px: 2,
                  py: 1.5,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: isSelected ? 'primary.main' : 'divider',
                  bgcolor: isSelected ? 'action.selected' : 'background.paper',
                }}
              />
            );
          })}
      </RadioGroup>
      {!isOnlinePaymentEnabled && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
          Online payment is not available for this bank.
        </Typography>
      )}
    </FormControl>
  );
}

export function PaymentPopup({
  onClose,
  onConfirm,
  isOnlinePaymentEnabled,
}: {
  onClose: () => void;
  onConfirm: (paymentType: string, paymentMode: string) => void;
  isOnlinePaymentEnabled: boolean;
}) {
  const [paymentMode, setPaymentMode] = React.useState('');

  const handleConfirm = (paymentMode: string) => {
    if (paymentMode) {
      onConfirm(paymentMode, paymentMode === 'online' ? 'DC' : paymentMode);
      onClose();
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          width: { xs: '95vw', sm: '600px', md: '700px' },
          borderRadius: 3,
          p: 1,
        },
      }}>
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: 22,
          pb: 1,
        }}>
        Choose Payment Method
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ px: 4, py: 3 }}>
        <PaymentSelector
          name="paymentType"
          value={paymentMode}
          onChange={setPaymentMode}
          isOnlinePaymentEnabled={isOnlinePaymentEnabled}
        />
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 3 }}>
        <Button
          fullWidth
          onClick={() => handleConfirm(paymentMode)}
          disabled={!paymentMode}
          variant="contained"
          size="large"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.5,
            fontSize: 16,
          }}>
          Confirm Payment
        </Button>
      </DialogActions>
    </Dialog>
  );
}
